import React from 'react';

export default ({ msg }) => (
  <div className="example-interface-notice">
    <p>{msg}</p>
  </div>
);
